import { VideoCompoundProps } from './VideoCompound.types'
import React from 'react'
import VideoComponent from './VideoComponent'

export const VideoCompound = (props: VideoCompoundProps) => {
  const { playlistId, videoId, inline, policy, account = '', shouldGrow } = props
  return playlistId && playlistId.length > 0 ? (
    <VideoComponent
      inline={inline}
      playlistId={playlistId}
      policy={policy}
      shouldGrow={shouldGrow}
      account={account}></VideoComponent>
  ) : (
    <VideoComponent
      inline={inline}
      videoId={videoId}
      policy={policy}
      shouldGrow={shouldGrow}
      account={account}></VideoComponent>
  )
}
